// extracted by mini-css-extract-plugin
export default {"title":"Experience_title__Bsf+l","company":"Experience_company__Gv3T9","points":"Experience_points__AOZNl","point":"Experience_point__hkQ0D"};